import React, { useState, useMemo } from 'react'
import { Document, Page } from 'react-pdf'

const PdfRender = ({ data }) => {
  const file = useMemo(() => (data), [data])
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [renderedPageNumber, setRenderedPageNumber] = useState(null)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset)
  }

  function previousPage() {
    changePage(-1)
  }

  function nextPage() {
    changePage(1)
  }

  const isLoading = renderedPageNumber !== pageNumber

  return (
    <>
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {isLoading && renderedPageNumber ? (
          <Page
            key={renderedPageNumber}
            className="prevPage"
            pageNumber={renderedPageNumber}
            height={514}
          />
        ) : null}
        <Page
          key={pageNumber}
          pageNumber={pageNumber}
          onRenderSuccess={() => setRenderedPageNumber(pageNumber)}
          height={514}
        />
      </Document>
      <div className="react-pdf-page-controls">
        <button
          disabled={pageNumber <= 1}
          onClick={previousPage}
          type="button"
          aria-label="Página anterior"
        >
          <i className="ri-arrow-left-s-line font-size-16" />
        </button>
        <span>
          pág.
          {' '}
          {pageNumber}
          {' '}
          de
          {' '}
          {numPages}
        </span>
        <button
          disabled={pageNumber >= numPages}
          onClick={nextPage}
          type="button"
          aria-label="Próxima página"
        >
          <i className="ri-arrow-right-s-line font-size-16" />
        </button>
      </div>
    </>
  )
}

export default PdfRender
